import React, { lazy, Suspense } from "react";
import Select from "react-select";
import SelectBrands from "../SelectBrands";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
const AccordionCustomersList = lazy(() => import("./AccordionCustomersList"));
export default function CustomersListModal({
  handleClose,
  show,
  addOrUpdateCustomerList,
  errorMessage,
  loader,
  handleInputChange,
  setNameCustomerList,
  setSearchValue,
  valueGroupement,
  nameCustomerList,
  allGroups,
  valueStatus,
  allStatus,
  setStatus,
  valueTags,
  setTags,
  getCustomersByGroupsStatusSearch,
  handleImportId,
  textImportId,
  getCustomersByImportIds,
  noResultMessageInModal,
  isAllChecked,
  checkedCustomersIds,
  setCheckedCustomersIds,
  customersListFilter,
  deleteAccordionSearch,
  loaderAddUpdate,
  setGroupement,
  handleModalHide,
  searchValue,
  updateCustomerData,
  nameModal,

  // <JC
  valueBrands,
  setBrands,
  allBrands,
  // JC>


}) {
  return (
    <Modal show={show} size="xl" onHide={() => handleModalHide()} centered>
      {!loaderAddUpdate ? (
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            addOrUpdateCustomerList();
          }}
        >
          <Modal.Header closeButton>
            <div className="row w-100 me-2 align-items-center">
              <div className="col-md-4">
                <Modal.Title>{nameModal} une liste clients</Modal.Title>
              </div>

              {/*
              <JC
              Select de la marque
              */
             console.log(nameModal)
              }
              <div className="col-md-3 pb-3">
                <Select
                  className="black border-white"
                  placeholder="Marque..."
                  required
                  value={valueBrands}
                  name="brands"
                  onChange={(e) => {
                    console.log(e);
                    setBrands(e);
                  }}
                  options={allBrands}
                />
              </div>
              {/*
              JC>
              */}

              <div className="col-md-5">
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    required
                    autoFocus
                    value={nameCustomerList}
                    onChange={(e) => {
                      handleInputChange(e);
                      setNameCustomerList(e.target.value);
                    }}
                    placeholder="Nom de la liste..."
                    name="nameCustomerList"
                  />
                </Form.Group>
              </div>
              <div className="col-md-12">
                {errorMessage && (
                  <div className="col-md-12 mb-3 p-1">
                    <Alert variant="danger" className="m-0">
                      {errorMessage}
                    </Alert>
                  </div>
                )}
              </div>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="row align-items-center">
              <div className="col-md-2">
                <Form.Control
                  type="search"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder={"Rechercher client/code tiers"}
                  className="search w-100"
                  aria-label="Search"
                />
              </div>
              <div className="col-md-2">
                <Select
                  className="black border-white search"
                  placeholder="Groupement.."
                  required
                  value={valueGroupement}
                  name="groupement"
                  onChange={(e) => {
                    setGroupement(e);
                  }}
                  options={allGroups}
                />
              </div>
              <div className="col-md-2">
                <Select
                  className="black border-white"
                  placeholder="Statut..."
                  required
                  value={valueStatus}
                  name="status"
                  onChange={(e) => {
                    setStatus(e);
                  }}
                  options={allStatus}
                />
              </div>
              <div className="col-md-4">
                <SelectBrands
                  brand={valueTags}
                  setBrand={setTags}
                  handleInputChange={handleInputChange}
                  isFromFormUser={true}
                />
              </div>
              <div className="col-md-2">
                <Button onClick={() => getCustomersByGroupsStatusSearch()}>
                  Rechercher
                </Button>
              </div>
            </div>
            <div className="row align-items-center mt-3">
              <div className="col-md-10">
                <Form.Control
                  as="textarea"
                  placeholder="Copier/Coller vos codes tiers ici"
                  rows={3}
                  value={textImportId}
                  onChange={handleImportId}
                />
              </div>
              <div className="col-md-2">
                <Button onClick={() => getCustomersByImportIds()}>
                  Import codes tiers
                </Button>
              </div>
            </div>
            {noResultMessageInModal && (
              <div className="col-md-12 mt-3">
                <div className="text-center red">Aucun résultat trouvé...</div>
              </div>
            )}
            <div className="row mt-3">
              <div className="col-md-12">
                <Form.Check
                  key={`$select-all`}
                  label={`Tout sélectionner`}
                  name="customersList"
                  type="checkbox"
                  id={`checkbox-select-all`}
                  value={
                    isAllChecked.length === checkedCustomersIds.length
                      ? true
                      : false
                  }
                  checked={
                    isAllChecked.length === checkedCustomersIds.length
                      ? true
                      : false
                  }
                  readOnly
                  onClick={() => {
                    if (isAllChecked.length === checkedCustomersIds.length) {
                      setCheckedCustomersIds([]);
                    } else {
                      setCheckedCustomersIds(isAllChecked);
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-md-12 mt-5">
              {!loader ? (
                <>
                  {nameModal === "Modifier" &&
                    updateCustomerData &&
                    updateCustomerData.length > 0 && (
                      <Suspense fallback={<div>Loading...</div>}>
                        <AccordionCustomersList
                          keyProp={"1-last-customers"}
                          dataCustomersList={{
                            group_name: "Clients précèdemment sélectionnés",
                            customers_status: "",
                            customers_tags: "",
                            customers: updateCustomerData,
                          }}
                          checkedCustomersIds={checkedCustomersIds}
                          setCheckedCustomersIds={setCheckedCustomersIds}
                          deleteAccordionSearch={deleteAccordionSearch}
                        ></AccordionCustomersList>
                      </Suspense>
                    )}
                  {customersListFilter &&
                    customersListFilter.map((elt, i) => (
                      <Suspense
                        fallback={<div>Loading...</div>}
                        key={i + "update-customers-loading"}
                      >
                        <AccordionCustomersList
                          key={i + "update-customers-lists"}
                          keyProp={i}
                          dataCustomersList={elt}
                          checkedCustomersIds={checkedCustomersIds}
                          setCheckedCustomersIds={setCheckedCustomersIds}
                          deleteAccordionSearch={deleteAccordionSearch}
                        ></AccordionCustomersList>
                      </Suspense>
                    ))}
                </>
              ) : (
                <div className="text-center">
                  <Spinner
                    animation={loader ? "border" : false}
                    role="status"
                  ></Spinner>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="is-bottom-right">
            <Button
              variant="secondary"
              onClick={() => {
                handleClose();
              }}
            >
              Annuler
            </Button>
            <Button
              variant="success"
              disabled={
                checkedCustomersIds.length > 0 && nameCustomerList && !loader
                  ? false
                  : true
              }
              type="submit"
            >
              Valider
            </Button>
          </Modal.Footer>
        </Form>
      ) : (
        <div className="text-center">
          <Spinner
            animation={loaderAddUpdate ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      )}
    </Modal>
  );
}
